export default class MobCursorMarker {
    private mMobCloseCursor: Phaser.GameObjects.Image;
    private mMobCloseCursorSpeed: number = 5;
    private startX: number;
    private endX: number;

    create(scene, endX) {
        const halfMarkSize = 16
        this.mMobCloseCursor = scene.add.image(scene.scale.width - halfMarkSize, scene.scale.height - halfMarkSize, "redMark");
        this.mMobCloseCursor.setDepth(5);
        this.startX = scene.scale.width - halfMarkSize;
        this.endX = endX;
    }

    update(monsters) {
        if (monsters.length > 0) {
            let closestX = monsters[0].GetX();
            let closestMob = monsters.findLast(m => {
                let isCurrentCloser = m.GetX() <= closestX;
                if (isCurrentCloser) {
                    closestX = m.GetX();
                }
                return isCurrentCloser;
            });

            if (closestMob === undefined) {
                console.debug("Oops bug");
            }
            else if (this.mMobCloseCursor.x < closestMob.GetX()) {
                // make it go to the right again
                this.mMobCloseCursor.setX(this.mMobCloseCursor.x + this.mMobCloseCursorSpeed);
            }
            else {
                this.mMobCloseCursor.setX(closestMob.GetX());
            }
        }
        else {
            if (this.mMobCloseCursor.x < this.startX) {
                this.mMobCloseCursor.setX(this.mMobCloseCursor.x + this.mMobCloseCursorSpeed);
            } else {
                this.mMobCloseCursor.setX(this.startX);
            }
        }

        if (this.mMobCloseCursor.x < this.endX) {
            this.mMobCloseCursor.setX(this.endX);
        }
    }

    GetPositionPercentFromEnd() {
        return ((this.mMobCloseCursor.x - this.endX) / (this.startX - this.endX)) * 100;
    }
}